export class VehicleTireTreadQueryParameters {
  id?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  tread?: string;

  constructor(obj?: VehicleTireTreadQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
